import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import SettingRepository from '../repositories/SettingRepository';

export const useBannerStore = defineStore('banner', () => {
    const settingRepository = new SettingRepository();

    const color = ref<string>('#f59e0b');
    const dismissed = ref<boolean>(window.sessionStorage.getItem('banner_dismissed') === '1');
    const text = ref<string>('');

    const visible = computed(() => text.value !== '' && !dismissed.value);

    async function fetch() {
        const data = await settingRepository.index();

        color.value = data.banner_color;
        text.value = data.banner_text ?? '';
    }

    function dismiss() {
        dismissed.value = true;

        window.sessionStorage.setItem('banner_dismissed', '1');
    }

    return {
        color,
        dismiss,
        dismissed,
        fetch,
        text,
        visible,
    }
});
